var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-root"},[_c('div',{staticClass:"app-main"},[(_vm.show)?_c('router-view'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }